import NavigationBar from './navigation-bar';
import Reports from './reports';
import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";
import Home from './home';
import Projects from './projects';
import { useAuth0 } from '@auth0/auth0-react';
import { ToastContainer } from 'react-toastify';

function App() {
  const { isAuthenticated } = useAuth0();

  return (
    <BrowserRouter>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        newestOnTop
        closeOnClick
        rtl={false}
        style={{ width: '370px' }}
      />
      <NavigationBar />
      <div className="container-fluid">
        <Routes>
          <Route path="/" element={<Home />} />
          {
            isAuthenticated ? <>
              <Route path="projects" element={<Projects />} />
              <Route path="reports" element={<Reports />} />
            </> : null
          }
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
